import { render, staticRenderFns } from "./editMuliple.vue?vue&type=template&id=22d256a1&scoped=true&lang=pug"
import script from "./editMuliple.vue?vue&type=script&lang=js"
export * from "./editMuliple.vue?vue&type=script&lang=js"
import style0 from "./editMuliple.vue?vue&type=style&index=0&id=22d256a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d256a1",
  null
  
)

export default component.exports